import { Facility } from "../../../../../../api/facility";
import {
  buildFacilityInfoRows,
  getCountryName,
  getFacilityOwnershipLabel,
  getFacilityTypeLabel,
  mapEnergyTableRows,
  mapHeatTableRows,
  mapRefrigerantTableRows,
  mapWaterTableRows,
  resolveOptionLabel
} from "../../../../../../screens/facility/facilityDrawer/utils/facilitySourceRows.utils";
import { FacilityViewModel } from "./externalStorageFacility.types";

export {
  resolveOptionLabel,
  getFacilityTypeLabel,
  getFacilityOwnershipLabel,
  getCountryName,
  buildFacilityInfoRows,
  mapEnergyTableRows,
  mapHeatTableRows,
  mapWaterTableRows,
  mapRefrigerantTableRows
};

type OptionItem = { text?: string; value?: string | number };
type CountryOption = { id?: string; country?: string; value?: string; text?: string };

export const buildFacilityViewModel = ({
  facility,
  originalFacility,
  countries,
  energyTypes,
  heatTypes,
  waterTypes,
  refrigerantTypes,
  showOriginalPanel
}: {
  facility: Facility | undefined;
  originalFacility: Facility | undefined;
  countries: CountryOption[] | undefined;
  energyTypes: OptionItem[] | undefined;
  heatTypes: OptionItem[] | undefined;
  waterTypes: OptionItem[] | undefined;
  refrigerantTypes: OptionItem[] | undefined;
  showOriginalPanel: boolean;
}): FacilityViewModel | null => {
  if (!facility) {
    return null;
  }

  return {
    title: facility.facilityName || "Facility",
    subtitle: showOriginalPanel ? "Simulated facility" : undefined,
    infoRows: buildFacilityInfoRows(facility, countries),
    originalInfoRows: showOriginalPanel ? buildFacilityInfoRows(originalFacility, countries) : [],
    energyRows: mapEnergyTableRows(facility.energy, energyTypes),
    heatRows: mapHeatTableRows(facility.heatSource, heatTypes),
    waterRows: mapWaterTableRows(facility.waterSource, waterTypes),
    refrigerantRows: mapRefrigerantTableRows(facility.refrigerantSource, refrigerantTypes),
    showOriginalPanel
  };
};
